import PrimaryHint from '@components/atoms/buttons/PrimaryHint';
import LotRowData from '@components/atoms/tables/lot/LotRowData';
import LotRowHeader from '@components/atoms/tables/lot/LotRowHeader';
import { useScreenName } from '@hooks/useScreenName';
import { Lot } from '@models/api/user/portfolio';
import { tooltipView } from '@services/analytics';
import { FormattedMessage } from '@utils/i18n';
import { AnalyticsContentId } from 'mh-client';
import dayjs from 'dayjs';

interface Props extends Lot {
    cytag?: string;
}

const LotRow = ({ date, isMatured, maturationDate, cytag, ...lot }: Props) => {
    const screenName = useScreenName();
    return (
        <div className="flex flex-col w-full gap-y-2">
            <div className="Body-XS flex font-Noto items-center w-full justify-between">
                <span className="items-center flex">
                    {dayjs(date).format('YYYY-MM-DD')}
                </span>
                {isMatured ? (
                    <span data-cy={cytag}>
                        {dayjs(maturationDate).format('YYYY-MM-DD')}
                    </span>
                ) : (
                    <PrimaryHint
                        title={
                            <FormattedMessage id="invest_act_maturation_state" />
                        }
                        body={
                            <FormattedMessage id="invest_act_maturation_state_body" />
                        }
                        icon="warning"
                        data-cy={cytag}
                        onClick={() =>
                            tooltipView(
                                screenName,
                                AnalyticsContentId.getInstance()
                                    .MATURATION_STATUS
                            )
                        }
                    >
                        <FormattedMessage
                            id="invest_act_matures_on_"
                            values={{
                                0: dayjs(maturationDate).format('YYYY-MM-DD'),
                            }}
                        />
                    </PrimaryHint>
                )}
            </div>
            <LotRowHeader />
            <LotRowData {...lot} />
        </div>
    );
};

export default LotRow;
